import { render, staticRenderFns } from "./CouponViewInfoCard.vue?vue&type=template&id=f90b93e4&"
import script from "./CouponViewInfoCard.vue?vue&type=script&lang=js&"
export * from "./CouponViewInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponViewInfoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports